<button class="sp-p-8 button" [attr.aria-label]="'expand_all_checkins' | localize" (click)="changeStatus(true)" ui-button>
  <i ui-icon uiType="arrows-out"></i>
</button>

<button class="sp-p-8 button" [attr.aria-label]="'collapse_all_checkins' | localize" (click)="changeStatus(false)" ui-button>
  <i ui-icon uiType="arrows-in"></i>
</button>
